"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
function stopWirelessPresentation() {
    return { type: constants_1.remoting.actions.WIRELESS_PRESENTATION_STOP };
}
exports.default = {
    stopWirelessPresentation
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/actions/wireless-presentation.js
// module id = 223
// module chunks = 0